import React, { FC } from 'react';
import { MaterialDTO } from 'src/common/models/material';
import styled, { css } from 'styled-components';
import { colors } from 'src/config/colors';
import { media } from 'src/config/breakpoints';
import { MaterialDownload } from 'src/common/components/MaterialDownload';

const MaterialsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  color: ${colors.blue};

  ${media.w.min.px768(css`
    gap: 0.625rem;
  `)};

  a {
    color: inherit;

    &:hover {
      cursor: pointer;
    }
  }
`;

export interface CourseBundleMaterialListProps {
  materials: MaterialDTO[];
  isUserEnrolled: boolean;
}

export const CourseBundleMaterialList: FC<CourseBundleMaterialListProps> = ({
  materials,
  isUserEnrolled,
}) => (
  <MaterialsList>
    {materials.map((material) => (
      <MaterialDownload key={material.id} material={material} isUserEnrolled={isUserEnrolled} />
    ))}
  </MaterialsList>
);
